import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class NVProjectMilestoneApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'project-milestone'
    }

}